import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

import { MAX_API_DAYS_TO_FETCH } from '../../../../../../features/vehicle-dispatch-boards/utils/board-api-days-to-fetch'

const DAYS_TO_FETCH_LOCAL_STORAGE_KEY = 'vdb:daysToFetch'

/**
 * 配車板の取得期間を管理するatom
 * デフォルト値: 3 = 前日 + 当日 + 翌日 の計3日間
 * 日俯瞰モードでは7/14/31が入る（UI表示用）
 */
export const daysToFetchAtom = atomWithStorage<number>(
  DAYS_TO_FETCH_LOCAL_STORAGE_KEY,
  3,
  undefined,
  {
    // 初回から Storage の値を使う
    getOnInit: true
  }
)

daysToFetchAtom.debugLabel = 'daysToFetchAtom'

/**
 * 配車板APIに渡すdaysToFetch（BE上限でクランプ）
 * daysToFetchAtomが14/31でも、APIには最大9を渡す。
 * 既存APIを呼ぶ箇所は全てこちらを使うこと。
 */
export const apiDaysToFetchAtom = atom((get) =>
  Math.min(get(daysToFetchAtom), MAX_API_DAYS_TO_FETCH)
)

apiDaysToFetchAtom.debugLabel = 'apiDaysToFetchAtom'
